<template>
    <div class="library-commented-on-by-filter" data-testid="library-commented-on-by-filter">
        <CollapsibleWidget>
            <template #name>Comments</template>

            <RadioGroup :model-value="commentedOnByFilter">
                <Radio
                    v-for="filter in BannerQaCommentedOnByFilter"
                    :key="filter"
                    :label="filter"
                    @click.stop.prevent="setCommentedOnByFilter(filter)"
                >
                    {{ BannerQaCommentedOnByFilterLabel[filter] }}
                </Radio>
            </RadioGroup>
        </CollapsibleWidget>
    </div>
</template>

<script lang="ts">
import CollapsibleWidget from "@/components/Campaign/widgets/CollapsibleWidget.vue";
import { BannerQaCommentedOnByFilter, BannerQaCommentedOnByFilterLabel } from "@/enums/banners";
import { DeliverableLibraryAction, DeliverableLibraryGetters } from "@/store/modules/deliverableLibrary";

export default {
    components: {
        CollapsibleWidget
    },

    data() {
        return {
            BannerQaCommentedOnByFilter,
            BannerQaCommentedOnByFilterLabel
        };
    },

    computed: {
        commentedOnByFilter: {
            get() {
                return this.$store.getters[DeliverableLibraryGetters.commentedOnByFilter];
            },
            set(value: (typeof BannerQaCommentedOnByFilter)[keyof typeof BannerQaCommentedOnByFilter]) {
                this.$store.dispatch(DeliverableLibraryAction.UpdateCommentedOnByFilter, value);
            }
        }
    },

    methods: {
        setCommentedOnByFilter(
            commentedOnBy: (typeof BannerQaCommentedOnByFilter)[keyof typeof BannerQaCommentedOnByFilter]
        ) {
            this.commentedOnByFilter = commentedOnBy;
        }
    }
};
</script>

<style lang="scss">
@use "@style/variables" as *;

.library-commented-on-by-filter {
    .ivu-radio {
        margin: 0;
    }

    .ivu-radio-group {
        display: block;
    }

    .ivu-radio-wrapper {
        margin: 0;
        padding: 0 0 0 50px;
        display: block;
    }
}
</style>
